import React, { useState, useEffect, useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import CloudImage from "../../Images/Cloud-consulting-and-services.svg";
import Footer from "../Footer/Footer.js";
import DetailsCard, {
  ThreeColumnContainer,
} from "../WhatWeDo/components/DetailsCard.js";
import cardData from "../../resources/cardData.json";
import imageHeader from "../../resources/imageHeader.json";
import SliderPage from "../WhatWeDo/components/SliderPage.js";
import SubHeadings from "../WhatWeDo/components/SubHeadings.js";
import ImageHeader from "../WhatWeDo/components/ImageHeader.js";
import { ReactComponent as CloudServices } from "../../Images/cloud_services.svg";
import { ReactComponent as CloudMigration } from "../../Images/cloud_migration.svg";
import { ReactComponent as CloudDevelopment } from "feather-icons/dist/icons/upload-cloud.svg";
import { ReactComponent as CloudOptimization } from "../../Images/cloud_optimization.svg";
import { ReactComponent as DatabaseConsulting } from "../../Images/database_consulting.svg";
import { ReactComponent as DevopsConsulting } from "feather-icons/dist/icons/code.svg";
import { useNavigate } from "react-router-dom";
import LogosCard from "../WhatWeDo/components/CloudLogoCard";
import cloudComputing from "../../Images/cloudComputing1.jpg";
import WhoWeAre from "../WhoWeAre/WhoWeAre.js";
import RealEstateTechstack from "../Techstack/RealEstateTechstack.js";
import ContactUs from "../Contact/ContactUs.js";
import { ContactUsPDF } from "./CommonPages/ContactUsPDF.js";
import Slider from "../WhatWeDo/components/Slider.js";
import TeckStackPDF from "./CommonPages/TeckStackPDF.js";
import WhoWeArePDF from "./CommonPages/WhoWeArePDF.js";

const Container = tw.div`relative  bg-center 
bg-no-repeat
h-screen
w-full`;
const TwoCol = styled.div`
  ${tw`flex justify-between max-w-screen-xl mx-auto`}
`;
const LogoContainer = tw.div`flex lg:justify-end absolute z-1 w-full`;
const LogoText = tw.h5`ml-0 text-6xl pt-5 text-indigo-600 font-bold text-white `;
const WrapperDescription = tw.div`max-w-screen-xl mx-auto shadow-lg`;
const Description = tw.p`px-6 font-semibold py-2  text-xl text-gray-900 text-justify`;

let data = [
  {
    imageSrc: <CloudServices />,
  },
  {
    imageSrc: <CloudMigration />,
  },
  {
    imageSrc: <CloudDevelopment />,
  },
  {
    imageSrc: <CloudOptimization />,
  },
  {
    imageSrc: <DatabaseConsulting />,
  },
  {
    imageSrc: <DevopsConsulting />,
  },
];
const keyBenefits = cardData.cloudservices.keyBenefits.map((item, index) => (
  <DetailsCard
    key={index}
    title={item.point}
    description={item.description}
    imageSrc={data[index].imageSrc}
  />
));

const CloudPagePdf = (props) => {
  let [current, setCurrent] = useState(0);

  let slidesData = [
    {
      image: cloudComputing,
      typeID: "element4",
      typedHead:
        "Increase resiliency and make your business global by benefiting from moving your systems to the cloud.",
      heading1: "Cloud consulting ",
      heading2: "and services",
      route: "/what-we-do/cloud-services",
      routeState: "",
      buttonName: "Visit",
    },
  ];

  let slides = [<SliderPage slidesData={slidesData[0]} imagehalf={true} />];

  useEffect(() => {
    document.title = "Welcome to Iqura - Cloud Consulting  & Services";
    let descMeta = document.querySelector("meta[name='description']");
    descMeta.setAttribute(
      "content",
      "Iqura Services are designed to empower your organization with the flexibility, scalability, and security offered by cloud technologies."
    );
    let keyword = document.querySelector("meta[name='keywords']");
    keyword.setAttribute(
      "content",
      "Cloud Services, Devops Consulting, Database Consulting, Cloud optimization, Cloud development and Cloud migration"
    );
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href = "https://www.iqura.tech/what-we-do/cloud-services";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const childRef = useRef(null);
  const handleBreadCrumbClose = () => {
    if (childRef.current) {
      childRef.current.handleClick();
    }
  };

  return (
    <>
      <div className="overflow-hidden relative ">
        <div
          style={{ visibility: "hidden", position: "absolute", top: "-9999px" }}
        >
          <Slider />
        </div>
      </div>
      <LogoContainer className={props.home === "pdf" && "mr-16 "}>
        <div className="flex lg:justify-end w-full mr-16 ">
          <LogoText className="logoFontFamily">Iqura</LogoText>
        </div>
      </LogoContainer>
      <div className="overflow-hidden relative  ">
        <div
          className="flex transition-transform ease-out duration-300 "
          style={{
            transform: `translateX(-${current * 100}%)`,
          }}
        >
          {slides.map((s) => {
            return (
              <div className="z-22" style={{ width: "100%" }}>
                {s}
              </div>
            );
          })}
        </div>

        <div className="absolute bottom-0 py-4 flex justify-center gap-3 w-full   ">
          {slides.map((s, i) => {
            return (
              <div
                onClick={() => {
                  setCurrent(i);
                }}
              ></div>
            );
          })}
        </div>
      </div>
      <Container onClick={handleBreadCrumbClose}>
        <TwoCol>
          <WrapperDescription>
            <Description
              style={{
                backgroundColor: "white",
                marginTop: `${window.innerWidth <= 425 ? -140 : -35}px`,
                padding: "40px",
                paddingTop: "80px",
                transform: "scale(1.25)",
              }}
            >
              <ImageHeader
                imageHeaderData={imageHeader.cloudConsulting}
                imgsource={CloudImage}
              />
            </Description>
          </WrapperDescription>
        </TwoCol>
        <WhoWeArePDF />
        <div
          className=" flex justify-center item-center"
          style={{ height: "100vh", paddingTop: "110px" }}
        >
          <div>
            <div style={{ height: "65vh" }}>
              <div style={{ transform: "scale(1.25)" }}>
                <SubHeadings heading1="Our" heading2="Services" />
                <ThreeColumnContainer>{keyBenefits}</ThreeColumnContainer>
              </div>
            </div>

            <div style={{ height: "35vh" }}>
              <div style={{ transform: "scale(1.25)"}}>
                <LogosCard />
              </div>
            </div>
          </div>
        </div>

        <TeckStackPDF />
        <ContactUsPDF />
      </Container>
    </>
  );
};

export default CloudPagePdf;
